import { render, staticRenderFns } from "./SignConsultant.vue?vue&type=template&id=3b60db4c&scoped=true"
import script from "./SignConsultant.vue?vue&type=script&lang=js"
export * from "./SignConsultant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b60db4c",
  null
  
)

export default component.exports